export default {
  version: "nkin-yv7j",
};
